import { ReactNode, useMemo } from 'react'

import { FeatureFlagSet } from 'hooks/feature-flags/featureFlagSet'
import { isZeusEnvironment } from 'utils/environment'

export const useFlags = (): FeatureFlagSet => {
  return useMemo(
    () => ({
      enableGlobalEdits: true,
      enableGrandCanyonErpSync: false,
      isSourcesRouteHidden: false,
      shouldShowReportingFormat: true,
      shouldShowPricingSettings: false,
      showRulesPageForGcOrg: false,
      showContactsPageForGcOrg: false,
      showCategoriesSettings: true,
      isStableCoinsEnabled: false,
      shouldEnableExpandedRoleBasedAccessControl: false,
      shouldShowAdvancedFilters: true,
      enableCustomFields: true,
      isPrincipalMarketAnalysisVisible: false,
      isPrincipalMarketAnalysisEnabled: false,
      isAccountingPageVisible: false,
      erpSyncForReadOnlyUsers: false,
      shouldAutomaticallyTranslate: false,
      enableSplitJournaling: false,
      areFeatureFlagsLoaded: true,
      shouldShowAllLegalEntityText: false,
      swapRollForwardReport: true,
      swapInventorySummaryReport: true,
      swapBalanceReport: true,
      swapFairValueReports: true,
      swapSignificantHoldingsReports: false,
      swapAsc35060Report: false,
      swapJournalEntryReports: false,
      isJournalingReportsEnabled: false,
      swapGainlossSummaryReport: true,
      swapImpairmentReports: false,
      enableRuleBasedPricing: false,
      enableAutomatedInternalTransferDetection: false,
      isSpamTokenAutoSyncEnabled: false,
      isPublicSector: false,
      isAssetTableGroupingEnabled: true,
      isSourceTaggingEnabled: true,
      isCustomErpMappingsEnabled: false,
      isMergeEnabled: true,
      isAuditLogEnabled: true,
      isMultiSourceFilteringEnabled: true,
      shouldShowPaymentsNavItem: false,
      isVoucherWorkflowEnabled: true,
      isMultiBookEnabled: false,
      isPriceLockingEnabled: false,
      shouldDisplayDailyPricesAsReferenceReport: false,
      enableOrgAwareUrls: false,
      enableDataVisibilityUi: true,
      enableBulkTxnEdits: true,
      shouldShowSlugInSelector: false,
      enableBulkWalletUpload: true,
      enableTxnEditReport: false,
    }),
    []
  )
}

export const asyncWithLDProvider = () =>
  Promise.resolve(({ children }: { children: ReactNode }) => children)

export const useLDClient = () => {
  return useMemo(() => ({ identify: () => undefined }), [])
}

/* eslint-disable no-console */
export const basicLogger = isZeusEnvironment()
  ? () => ({
      debug: console.debug,
      info: console.info,
      warn: console.warn,
      error: console.error,
    })
  : undefined
/* eslint-enable no-console */
